import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-gray-775" }
const _hoisted_2 = { class: "font-semibold text-2xl sm:text-3xl text-gray-775 text-left sm:text-center mt-10 sm:mt-[120px] mb-4 sm:mb-[40px]" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-12" }
const _hoisted_4 = { class: "sm:mt-[14px] lg:mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: "svg/why-trade-on-helix-01.svg",
    alt: ""
  })
], -1)
const _hoisted_6 = { class: "font-semibold text-xl mb-4" }
const _hoisted_7 = { class: "font-medium text-base mb-4 sm:mb-0" }
const _hoisted_8 = { class: "sm:mt-[9px] lg:mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: "svg/why-trade-on-helix-02.svg",
    alt: ""
  })
], -1)
const _hoisted_10 = { class: "font-semibold text-xl mb-4" }
const _hoisted_11 = { class: "font-medium text-base mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: "svg/why-trade-on-helix-03.svg",
    alt: ""
  })
], -1)
const _hoisted_13 = { class: "font-semibold text-xl mb-4" }
const _hoisted_14 = { class: "font-medium text-base" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('home.whyTradeOnHelix')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('home.decentralizedWithAdvancedTypeOrders')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('home.enjoySpotTrading')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('home.lowFees')), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('home.zeroGasFees')), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('home.crossChainAssets')), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('home.seamlesslyTransferAssets')), 1)
      ])
    ])
  ]))
}